import { ApiError } from "@/api";

export const REQUEST_NOT_ASSIGNED = "REQUEST_NOT_ASSIGNED";

/**
 * The server's refusal when an operator acts on a request that is not theirs (#803).
 *
 * It replaced a 409 ownership conflict that offered a takeover. There is no takeover any more, so
 * this carries no assignee to name and no action to offer: only which request was refused. The
 * console's job is to say plainly that the action did not happen and who can change that.
 */
export type RequestNotAssignedRefusal = {
  requestId: string;
};

export function requestNotAssignedRefusal(error: unknown): RequestNotAssignedRefusal | null {
  if (!(error instanceof ApiError) || error.status !== 403) return null;
  const data = error.data as Record<string, unknown> | null;
  if (data?.code !== REQUEST_NOT_ASSIGNED || typeof data.request_id !== "string") return null;
  return { requestId: data.request_id };
}
